<ng-container *transloco="let t">
  <ng-container *ngIf="((featuredReviews$ | async)?.length || 0) > 0">
    <section
      id="reviewsCard"
      class="featured-reviews-card"
      [class.widescreen]="(biggerThan$ | async)?.sm"
      [class.hugescreen]="(biggerThan$ | async)?.md">
      <span class="fixed-space-16" aria-hidden="true"></span>
      <!-- HEADER -->
      <section class="section-header">
        <h1 *ngIf="!collectionMode" class="label">{{ t('label_user_reviews') }}</h1>
        <h2 *ngIf="collectionMode" class="label">{{ t('label_user_reviews') }}</h2>

        <!-- STATS -->
        <section
          *ngIf="
            (featuredReviewsStats$ | async) &&
            (featuredReviewsStats$ | async)?.averageRating !== 0
          "
          class="stats">
          <div class="main-stats">
            <span class="flex flex-row">
              <popsy-icon-star-filled
                *ngFor="
                  let n of range((featuredReviewsStats$ | async)?.averageRating);
                  trackBy: trackByIndex
                "
                class="icon fill-gray-dark"></popsy-icon-star-filled>
              <popsy-icon-star-half-filled
                class="icon fill-gray-dark"
                *ngIf="isAverageRatingPointFive"></popsy-icon-star-half-filled>
              <span class="fixed-space-8" aria-hidden="true"></span>
              <span class="small"
                >({{ (featuredReviewsStats$ | async)?.totalCount }}
              </span>
              <span class="fixed-space-4" aria-hidden="true"></span>
              <span class="small"> {{ t('label_user_reviews') }} )</span>
            </span>
            <span> {{ (featuredReviewsStats$ | async)?.averageRating }} / 5</span>
          </div>

          <span class="fixed-space-32" aria-hidden="true"></span>

          <div class="star-ratings">
            <span
              class="flex"
              *ngFor="
                let rating of (featuredReviewsStats$ | async)?.countRatingStars
                  | slice: 1;
                index as i;
                trackBy: trackByIndex
              ">
              <span> {{ i + 1 }} {{ t('label_stars_ratings') }}</span>
              <span class="fixed-space-8" aria-hidden="true"></span>
              <div class="bar pill">
                <div
                  class="progress"
                  [style.width]="getRatingPercentage(rating) + '%'"></div>
              </div>
              <span class="fixed-space-8" aria-hidden="true"></span>
              <span> {{ getRatingPercentage(rating) }} %</span>
            </span>
          </div>
        </section>

        <span class="fixed-space-16" aria-hidden="true"></span>

        <!-- SORT PICKER -->
        <div
          *ngIf="!showAll"
          class="sort-menu popsy-button-secondary"
          (click)="toggleLanguagePicker()">
          <span #sortPicker class="flex flex-col">
            <span class="small light">{{ t('label_sort_by') }}</span>
            <span class="small">{{ t((selectedOption$ | async)?.display || '') }}</span>
          </span>
          <span class="fixed-space-8" aria-hidden="true"></span>

          <popsy-icon-arrow-down-1 class="icon gray-light"></popsy-icon-arrow-down-1>
        </div>
      </section>

      <span class="fixed-space-4" aria-hidden="true"></span>

      <!-- REVIEWS -->
      <ul
        class="grid"
        [class.sm]="(biggerThan$ | async)?.sm"
        [class.mobile]="(biggerThan$ | async)?.mobileL">
        <app-featured-reviews-item
          *ngFor="
            let review of featuredReviews$ | async | slice: 0 : reviewsLimit;
            trackBy: trackByReview
          "
          [review]="review"
          class="item">
        </app-featured-reviews-item>
      </ul>
      <span *ngIf="canShowMore" class="show-more">
        <span class="popsy-link link" (click)="showMore()">
          {{ t('action_view_more') }}</span
        >
      </span>
    </section>
  </ng-container>
</ng-container>
